import React from "react";
import styles from "./Composer.module.css";

interface HeaderProps {
  onClose?: () => void;
  handleResetChat: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onClose, handleResetChat }) => {
  return (
    <div className={styles.header}>
      <span className={styles.headerTitle}>New chat</span>
      <div className={styles.headerButtons}>
        <button
          className={styles.refreshButton}
          onClick={handleResetChat}
          aria-label="Reset chat"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.65 2.35C12.2 0.9 10.21 0 8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C11.73 16 14.84 13.45 15.73 10H13.65C12.83 12.33 10.61 14 8 14C4.69 14 2 11.31 2 8C2 4.69 4.69 2 8 2C9.66 2 11.14 2.69 12.22 3.78L9 7H16V0L13.65 2.35Z"
              fill="#B5B2AA"
            />
          </svg>
        </button>
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close chat"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 3.5L3.5 12.5M3.5 3.5L12.5 12.5"
              stroke="#B5B2AA"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
